import { render, staticRenderFns } from "./DisclaimerModal.vue?vue&type=template&id=44158c6e&scoped=true&"
import script from "./DisclaimerModal.vue?vue&type=script&lang=js&"
export * from "./DisclaimerModal.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerModal.vue?vue&type=style&index=0&id=44158c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44158c6e",
  null
  
)

export default component.exports